import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { Subscription } from 'rxjs';
import { RolesService } from 'src/app/services/roles-service/roles.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-roles-roles-dashboard',
  templateUrl: './roles-roles-dashboard.component.html',
  styleUrls: ['./roles-roles-dashboard.component.scss']
})
export class RolesRolesDashboardComponent implements OnInit, OnDestroy {

  roles;
  filterKey;
  noItemsConfig;
  getRoleListSubscription: Subscription;
  refreshRolesSubscription: Subscription;
  searchRolesSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private rolesService: RolesService,
              private snackbarService: SnackBarService) {
                this.noItemsConfig = this.setNoItemsConfig();
              }

  ngOnInit() {
    this.setBreadcrumb();
    this.getRolesList();
    this.refreshRolesSubscription = this.rolesService.refreshRolesListen().subscribe(
      (res) => {
        this.getRolesList();
      }
    );
    this.searchRolesSubscription = this.rolesService.searchRolesListen().subscribe(
      (res) => {
        this.filterKey = res;
      }
    );
  }

  private getRolesList() {
    this.getRoleListSubscription = this.rolesService.getRolesList().subscribe(
      (res) => {
        this.roles = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-magic', 'roles-page.roles', '/account', [new BRoute('account-page.account', '/account'), new BRoute('roles-page.roles')]));
  }

  private setNoItemsConfig() {
    return {
      description: 'roles-page.roles not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

  ngOnDestroy() {
    if (this.getRoleListSubscription) { this.getRoleListSubscription.unsubscribe(); }
  }

}
